import styled, { useTheme } from 'styled-components';
import { Heading3Text, ParagraphLargeText } from '../../../../components/Texts';
import WidthContainer from '../../../../components/WidthContainer';
import { PHONE_MEDIA_QUERY } from '../../../../common/responsive';
import ColorizedSpan from '../../../../components/Colorized';

const BackgroundContainer = styled.div`
  position: relative;
  width: 95%;
  padding: 80px 0;
  background-color: ${({ theme }) => theme.background.primary};
  @media ${PHONE_MEDIA_QUERY} {
    width: 100%;
    padding-top: 30px;
    padding-bottom: 30px;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 60px;
  @media ${PHONE_MEDIA_QUERY} {
    flex-direction: column;
    gap: 40px;
    text-align: center;
  }
`;

const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 1;
  max-width: 500px;
  @media ${PHONE_MEDIA_QUERY} {
    max-width: 100%;
    align-items: center;
  }
`;

const RightColumn = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  @media ${PHONE_MEDIA_QUERY} {
    justify-content: center;
    width: 100%;
  }
`;

const StyledParagraphLargeText = styled(ParagraphLargeText)`
  font-weight: 400;
`;

const Image = styled.img`
  width: 100%;
  max-width: 550px;
  height: auto;
  object-fit: contain;
  @media ${PHONE_MEDIA_QUERY} {
    max-width: 100%;
  }
`;

const HowToSpend = () => {
  const theme = useTheme();

  return (
    <BackgroundContainer>
      <WidthContainer>
        <Container>
          <LeftColumn>
            <Heading3Text style={{ color: theme.text.title, width: '100%' }}>
            Spend on popular <ColorizedSpan>brands</ColorizedSpan>
            </Heading3Text>
            <StyledParagraphLargeText>
              <>
                Use your crypto or stocks at popular,
                <br />
                real-world brands.
              </>
            </StyledParagraphLargeText>
          </LeftColumn>
          <RightColumn>
            <Image src="/landing-v2/spend.webp"/>
          </RightColumn>
        </Container>
      </WidthContainer>
    </BackgroundContainer>
  );
};

export default HowToSpend;
